import React, {lazy, Suspense} from 'react';
import SessionInstanceChatShimmerComponent from '../common/genericComponents/redesign/shimmerWithEmptyImageComponent/sessionInstanceChatShimmerComponent';

const SessionInstanceChatComponentLazy = lazy(() =>
  import('./sessionInstanceChatComponent').then((module) => ({
    default: module.default,
  })),
);

const SessionInstanceChatComponentWithSuspense = (props) => {
  return (
    <Suspense fallback={<SessionInstanceChatShimmerComponent />}>
      <SessionInstanceChatComponentLazy {...props} />
    </Suspense>
  );
};

export default SessionInstanceChatComponentWithSuspense;
